
import React, { Component } from 'react';
import './select-section.scss'
import { Modal, ModalBody } from "reactstrap";
import ReactTooltip from 'react-tooltip';
import SchoolApi from '../../../../apis/school'
import Dropdown from '../../../common/dropdown-v2/dropdown';
import { ImageConstants, } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import AddSection from '../../../dashboard/add-section/add-section'
import SetupSection from '../../../class/setup-section/setup-section'

class SelectSection extends Component {
    constructor(props) {
        super(props)

    }

    state = {
        existingUsers: [],
        types: [],
        title: "Assign a section for selected students",
        selectedUser: null,
        countryCodeDropdown: [],
        sectionDropdown: {},
        selectedClass: this.props.selectedClass,
        selectedBoard: this.props.selectedBoard,
        selectedSection: {},
        selectedClassName: null
    }

    userHash = {}

    componentDidMount() {
        this.getSections()
    }


    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass?.join(",")
        if (!payload.board) payload.board = this.state.selectedBoard

        SchoolApi.getSections(payload)
            .then(response => {
                let classDropdownHash = {};
                for (let i = 0; i < response?.response?.length; i++) {
                    let section = response?.response[i]
                    if (classDropdownHash[section.class]) {
                        classDropdownHash[section.class].push({
                            title: response?.response[i].section,
                            value: response?.response[i]._id,
                        })
                    } else {
                        classDropdownHash[section.class] = [{
                            title: response?.response[i].section,
                            value: response?.response[i]._id,
                        }]
                    }
                }

                this.setState({ sectionDropdown: classDropdownHash, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })

    }

    onSave() {

        this.setState({ isSubmit: true })
        let users = this.props.users || []
        if (!(users && users.length)) return

        let { payload, validation } = this.preparePayload(users)

        if (!validation) return

        SchoolApi.sectionBulkAssign(payload).then(response => {
            this.props.onSave && this.props.onSave(this.state?.section.title)
            this.setState({ isSubmit: false })
        }).catch(err => {
            this.setState({ isSubmit: false })
        })
    }

    preparePayload(users) {
        let selectedSection = this.state.selectedSection || {}
        let payload = []
        for (let i = 0; i < users.length; i++) {
            let user = users[i]
            let section = selectedSection[user.class]
            if (!section) return { validation: false }
            let obj = {
                id: user._id,
                section: section.title,
                sectionId: section.value
            }
            payload.push(obj)
        }
        return { payload: { students: payload }, validation: true }
    }

    validatePayload(payload) {

        return true
    }

    addNewSection = (key) => {
        this.setState({ showAddSection: true, selectedClassName: key })
    }

    closeAddSection = (value) => {
        if (value) {
            this.getSections()
        }
        this.setState({ showAddSection: false, selectedClassName: null })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    onSelectSection = (option, key) => {
        let selectedSection = this.state.selectedSection
        selectedSection[key] = option
        this.setState({ selectedSection, section: option })
    }

    renerSectionDropdown() {
        let arr = []

        for (let key in this.state.sectionDropdown) {
            let items = this.state.sectionDropdown[key]
            arr.push(
                <div className='row pt-2' onMouseEnter={ReactTooltip.rebuild}>
                    <div className='col-2 pr-0 my-auto text-right'>{key}</div>
                    <div className='col-8'>
                        {
                            !this.state.reloadDropdown ?
                                <Dropdown
                                    key="users"
                                    placeholder='Select from the list'
                                    options={items}
                                    onSelect={(option) => this.onSelectSection(option, key)}
                                    text="title"
                                    style={{ background: "#F6F7F5" }}
                                    value={this.state.selectedSection[key]?.value}
                                    invalid={this.state.isSubmit && !this.state.selectedSection[key]?.value}
                                />
                                : ""
                        }
                    </div>
                    <div className='col-2 my-auto'>
                        <img data-tip={"Add New Section"} className="custom-close-icon cursor-pointer" onClick={_ => this.addNewSection(key)} src={getImageSource(ImageConstants.ADD)} />
                    </div>

                </div>)
        }

        return arr
    }

    renderSetupSection() {
        return (
            <Modal className="cw-custom-modal modal-setup-section" isOpen={true} toggle={this.closeAddSection} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.closeAddSection} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    {/* <div className="header-text text-center">
                        <span>SETUP SECTIONS FOR {this.state.selectedClassName.toUpperCase()}</span>
                    </div> */}
                    <div className="px-4">
                        <SetupSection from="teachers" onClose={this.closeAddSection} class={this.state.selectedClassName} board={this.state.selectedBoard} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    render() {
        return (
            <div>
                <Modal className="cw-custom-modal" isOpen toggle={this.props.onClose} size={this.props.size || 'md'}>

                    <ModalBody >
                        <div className="select-section">
                            <div className="row">
                                <div className="col">
                                    <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                                </div>
                            </div>

                            <div className="header-text text-center px-4">
                                <span>{this.state.title}</span>
                            </div>

                            <div className="pt-4">
                                {this.renerSectionDropdown()}
                            </div>

                            <div className="text-center pt-5">
                                <button className="cw-button-primary" onClick={() => this.onSave()}>
                                    ASSIGN
                                </button>
                            </div>

                        </div>
                    </ModalBody>
                    <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
                </Modal >
                {
                    this.state.showAddSection ? this.renderSetupSection() : ""
                }
            </div>
        );
    }
}

export default SelectSection;